import * as api from 'api/utils';

export const fetchAllDepartments = (
  params = { statusName: 'Active', start: 0, limit: -1 }
) => ({
  type: 'FETCH_ALL_DEPARTMENTS',
  payload: api.fetchAllDepartments(params),
});

export const fetchAllRoles = () => ({
  type: 'FETCH_ALL_ROLES',
  payload: api.fetchAllRoles(),
});

export const fetchAllCategories = () => ({
  type: 'FETCH_ALL_CATEGORIES',
  payload: api.fetchAllCategories(),
});

export const fetchAllQuestionTypes = () => ({
  type: 'FETCH_ALL_QUESTION_TYPES',
  payload: api.fetchAllQuestionTypes(),
});

export const fetchAllConfigs = () => ({
  type: 'FETCH_ALL_CONFIGS',
  payload: api.fetchAllConfigs(),
});

export const updateConfigs = obj => ({
  type: 'UPDATE_CONFIGS',
  payload: api.updateConfigs(obj),
});

export const fetchAllUserStatus = () => ({
  type: 'FETCH_USER_STATUS',
  payload: api.fetchAllUserStatus(),
});

export const fetchAllVendorStatus = () => ({
  type: 'FETCH_VENDOR_STATUS',
  payload: api.fetchAllVendorStatus(),
});

export const fetchAllRequestStatus = () => ({
  type: 'FETCH_REQUEST_STATUS',
  payload: api.fetchAllRequestStatus(),
});

export const fetchUploadedFiles = vendorRequestID => ({
  type: 'FETCH_UPLOADED_FILES',
  payload: api.fetchUploadedFiles(vendorRequestID),
});

export const fetchAuditLog = params => ({
  type: 'FETCH_AUDIT_LOG',
  payload: api.fetchAuditLog(params),
});

export const fetchAuditLogExports = params => ({
  type: 'FETCH_AUDIT_LOG_EXPORTS',
  payload: api.fetchAuditLog(params),
});

export const fetchQuestionStatus = () => ({
  type: 'FETCH_QUESTION_STATUS',
  payload: api.fetchQuestionStatus(),
});
